import { render, staticRenderFns } from "./RouteDataTable.vue?vue&type=template&id=85a649c4&scoped=true&"
import script from "./RouteDataTable.vue?vue&type=script&lang=js&"
export * from "./RouteDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a649c4",
  null
  
)

export default component.exports